import { Box, Typography, Link } from "@mui/material"
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

const HelpText = ({ sx }) => {
  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      ...sx
    }}>
      <HelpOutlineOutlinedIcon sx={{ fontSize: '20px', mr: '10px' }} />
      <Typography variant="h4">
        Support :{' '}
        <Link
          href='mailto:help@descendantsdna.com'
          sx={{
            color: 'primary.black',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
        >
          help@descendantsdna.com
        </Link>
      </Typography>
    </Box>
  )
}

export default HelpText